// Orientation-cycle math for the map's alignment button, ported from the iOS
// app (react-native/src/map/orientCycle.js) so both platforms step the same
// ring: north-up → heading-up (device compass) → course-up (GPS) → off.
//
// "off" means different things by context — Live: stop following; Explore:
// "Free", keep whatever rotation you've gestured. `noOff` drops "off" from the
// ring (used while recording, where the button doubles as the ◎ recenter).

const ORDER = ["north", "heading", "course", "off"]

export function nextOrient({ enabled, current, noOff = false }) {
  const ring = ORDER.filter(m => enabled.includes(m) && !(noOff && m === "off"))
  if (!ring.length) return null
  const i = ring.indexOf(current)
  return ring[(i + 1) % ring.length] // current not in ring → first mode
}

export const ORIENT_LABELS = { north: "N↑", heading: "H↑", course: "C↑", off: "Free" }

// The camera bearing for an orientation:
//   north   → 0, heading → device compass, course → GPS course-over-ground,
//   off/free or missing input → null = "leave bearing as-is".
export function bearingForOrient(orientation, { course, deviceHeading } = {}) {
  if (orientation === "north") return 0
  if (orientation === "heading") return deviceHeading != null && deviceHeading >= 0 ? deviceHeading : null
  if (orientation === "course") return course != null && course >= 0 ? course : null
  return null
}
